module.exports = __webpack_public_path__ + "img/logo-footer@2x.839ad65.png";